
import { setComponentTemplate } from "@ember/component";
import template from "../template.hbs";
import templateOnlyComponent from "@ember/component/template-only";
export default setComponentTemplate(template, templateOnlyComponent(undefined, "template"));
